<script setup>
import Header from '../Formularios/Header.vue'
import { useForm, Link } from '@inertiajs/inertia-vue3';
import BannersBox from '../../../Shared/Banners/BannersBox.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFile } from '@fortawesome/free-solid-svg-icons'
library.add([faFile]);
</script>
<template>
    <Header :servicio="servicio" />
    <div class="contenido-wrapper">
        <div class="bloque-general">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="tramite-instrucciones">
                            <p>Llena el siguiente formulario para comenzar el trámite.</p>
                        </div>
                        <p>Al enviar el formulario un representante te contactará por medio del correo o teléfono que proporciones para continuar con el proceso.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bloque-general pt-0">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <form @submit.prevent="submit()">

                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.nombre }">
                                        <label>Nombre(s)</label>
                                        <input v-model="form.nombre" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.apellido_paterno }">
                                        <label>Apellido Paterno</label>
                                        <input v-model="form.apellido_paterno" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.apellido_paterno }">
                                        <label>Apellido Materno</label>
                                        <input v-model="form.apellido_materno" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.email }">
                                        <label>Correo electrónico</label>
                                        <input v-model="form.email" type="email" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.telefono }">
                                        <label>Teléfono celular</label>
                                        <input  v-model="form.telefono" type="tel" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.edad }">
                                        <label>Edad</label>
                                        <input v-model="form.edad" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.sexo }">
                                        <label>Sexo</label>
                                        <input  v-model="form.sexo" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" :class="{ 'not-valid': form.errors.direccion }">
                                <label for="form-direccion">Dirección</label>
                                <input v-model="form.direccion" type="text" class="form-control">
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="form-cp">CP</label>
                                        <input id="form-cp" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="form-rfc">RFC</label>
                                        <input id="form-rfc" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group form__input-wrapper">
                                        <label for="form-tipo-giro">Tipo de giro</label>
                                        <select id="form-tipo-giro" class="form-control form__select">
                                            <option disabled="" selected="" hidden="">Selecciona un giro</option>
                                            <option value="1">Tipo 1</option>
                                            <option value="2">Tipo 2</option>
                                            <option value="3">Tipo 3</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="form-celular">Teléfono celular</label>
                                        <input id="form-celular" type="tel" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="form-email">Correo electrónico</label>
                                        <input id="form-email" type="email" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="form-horarios">Horarios</label>
                                        <input id="form-horarios" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="form-fecha-inicio">Fecha de inicio</label>
                                        <input id="form-fecha-inicio" type="date" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="form-fecha-final">Fecha de finalización</label>
                                        <input id="form-fecha-final" type="date" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group form-group-radio-buttons">
                                <p>¿El trámite requiere firma, validación, certificación o autorización de otra dependencia?</p>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="requiere-firma-si" name="requiere-firma" class="custom-control-input" checked>
                                    <label class="custom-control-label" for="requiere-firma-si">Sí</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="requiere-firma-no" name="requiere-firma" class="custom-control-input">
                                    <label class="custom-control-label" for="requiere-firma-no">No</label>
                                </div>
                            </div>
                            <div class="form-group form-group-radio-buttons">
                                <p>¿El trámite se realiza con escrito libre?</p>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="escrito-libre-si" name="escrito-libre" class="custom-control-input" checked>
                                    <label class="custom-control-label" for="escrito-libre-si">Sí</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="escrito-libre-no" name="escrito-libre" class="custom-control-input">
                                    <label class="custom-control-label" for="escrito-libre-no">No</label>
                                </div>
                            </div>
                            <div class="form-group form-group-radio-buttons">
                                <p>Tipo de trámite</p>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="tipo-tramite-ciudadano" name="tipo-tramite" class="custom-control-input" checked>
                                    <label class="custom-control-label" for="tipo-tramite-ciudadano">Ciudadano</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="tipo-tramite-empresarial" name="tipo-tramite" class="custom-control-input">
                                    <label class="custom-control-label" for="tipo-tramite-empresarial">Empresarial</label>
                                </div>
                            </div>
                            <div class="form-group">
                                <p>Adjunta a continuación los requisitos solicitados</p>
                                <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFile01">
                                    <label class="custom-file-label" for="inputGroupFile01" data-txt-button="Selecciona un archivo">Ningún archivo seleccionado</label>
                                </div>
                            </div>
                            <div class="form-group-submit">
                                <div class="response-output show" v-if="form.hasErrors">
                                    <p>Por favor completa los campos faltantes</p>
                                    <ul>
                                        <li v-for="(error, i) in form.errors" :key="i">{{ error }}</li>
                                    </ul>
                                </div>
                                <button type="submit" :disabled="form.processing">{{ (form.processing) ? 'Enviando ...' :
                                    'Solicitar trámite'
                                }}</button>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        servicio: Object,
        banners: Object,
    },
    data() {
        return {
            form: useForm({
                nombre: '',
                apellido_paterno: '',
                apellido_materno: '',
                telefono: '',
                email: '',
                id: this.servicio.id,
                slug: this.servicio.slug,
            }),
        }
    },
    methods: {
        submit() {
            this.form.post(route('servicios.formulario.save'), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        }
    }
}
</script>
<style scoped>
.pre {
    white-space: break-spaces;
}

.boton-descarga:hover {
    color: #000;
    text-decoration: none;
}
</style>
